export const data = {
  across: {
    1: {
      clue: 'What I swore I would not call you but I do all the time now!',
      answer: 'BOOPS',
      row: 0,
      col: 10,
    },
    2: {
      clue: 'What is your favorite flower?',
      answer: 'TULIP',
      row: 3,
      col: 10,
    },
    4: {
      clue: 'How long will I love you ;)',
      answer: 'FOREVER',
      row: 4,
      col: 2,
    },
    7: {
      clue: 'Where was our first date?',
      answer: 'VOLCANO',
      row: 6,
      col: 9,
    },
    8: {
      clue: 'Shipname?!?!',
      answer: 'BRITTLER',
      row: 7,
      col: 0,
    },
    9: {
      clue: 'What describes your aesthetic?',
      answer: 'BADDIE',
      row: 8,
      col: 9,
    },
    10: {
      clue: 'When I answer the phone: "Hey, ___"',
      answer: 'SHMUCKUMS',
      row: 10,
      col: 6,
    },
  },
  down: {
    1: {
      clue: 'Who is my favorite person?',
      answer: 'BRITT',
      row: 0,
      col: 10,
    },
    3: {
      clue: 'Another phrase used when answering the phone: "Ohhh, ___!"',
      answer: 'PWINCESS',
      row: 3,
      col: 14,
    },
    5: {
      clue: 'What\'s my favorite thing about you?',
      answer: 'EVERYTHING',
      row: 4,
      col: 7,
    },
    6: {
      clue: 'Where did we first spot one another',
      answer: 'HINGE',
      row: 6,
      col: 2,
    },
    11: {
      clue: 'What do your eyes remind me of / What\'s your favorite drink?',
      answer: 'MATCHA',
      row: 10,
      col: 13,
    },
  }
};

export const badData = {
  across: {
    1: {
      clue: 'What do your eyes remind me of/ What\'s your favorite drink?',
      answer: 'MATCHA',
      row: 0,
      col: 0,
    },
    3: {
      clue: 'What is your favorite flower?',
      answer: 'TULIP',
      row: 1,
      col: 0,
    },
    5: {
      clue: 'Where did we first spot one another?',
      answer: 'HINGE',
      row: 2,
      col: 0,
    },
    7: {
      clue: 'Where was our first date?',
      answer: 'VOLCANO',
      row: 3,
      col: 0,
    },
    9: {
      clue: 'How long will I love you?',
      answer: 'FOREVER',
      row: 4,
      col: 0,
    },
    11: {
      clue: 'My favorite feature about you?',
      answer: 'EVERYTHING',
      row: 5,
      col: 0,
    },
    13: {
      clue: 'Who is my favorite person?',
      answer: 'BRITT',
      row: 6,
      col: 0,
    },
    15: {
      clue: 'What describes your aesthetic?',
      answer: 'BADDIE',
      row: 7,
      col: 0,
    },
    17: {
      clue: 'Shipname?!?',
      answer: 'BRITTLER',
      row: 8,
      col: 0,
    },
    19: {
      clue: 'When I answer the phone: "Hey, ___"?',
      answer: 'SHMUCKUMS',
      row: 9,
      col: 0,
    },
    21: {
      clue: 'Another phrase used when answering the phone:',
      answer: 'PWINCESS',
      row: 10,
      col: 0,
    },
    23: {
      clue: 'What I swore I would not call you but I do all the time now:',
      answer: 'BOOPS',
      row: 11,
      col: 0,
    },
  },
  down: {
    2: {
      clue: 'What describes your aesthetic?',
      answer: 'BADDIE',
      row: 0,
      col: 7,
    },
    4: {
      clue: 'Where was our first date?',
      answer: 'VOLCANO',
      row: 0,
      col: 3,
    },
    6: {
      clue: 'Who is my favorite person?',
      answer: 'BRITT',
      row: 0,
      col: 6,
    },
    8: {
      clue: 'What do your eyes remind me of/ What\'s your favorite drink?',
      answer: 'MATCHA',
      row: 0,
      col: 0,
    },
    10: {
      clue: 'Shipname?!?',
      answer: 'BRITTLER',
      row: 0,
      col: 8,
    },
    12: {
      clue: 'How long will I love you?',
      answer: 'FOREVER',
      row: 0,
      col: 4,
    },
    16: {
      clue: 'When I answer the phone: "Hey, ___"?',
      answer: 'SHMUCKUMS',
      row: 0,
      col: 9,
    },
    18: {
      clue: 'Another phrase used when answering the phone:',
      answer: 'PWINCESS',
      row: 0,
      col: 10,
    },
    20: {
      clue: 'What is your favorite flower?',
      answer: 'TULIP',
      row: 1,
      col: 0,
    },
    22: {
      clue: 'Where did we first spot one another?',
      answer: 'HINGE',
      row: 2,
      col: 0,
    },
    24: {
      clue: 'My favorite feature about you?',
      answer: 'EVERYTHING',
      row: 5,
      col: 0,
    },
  },
};

export const harryData = {
  across: {
    3: {
      clue: 'Styles\'s zodiac sign',
      answer: 'AQUARIUS',
      row: 1,
      col: 13
    },
    7: {
      clue: 'Harry Styles\' debut solo single',
      answer: 'SIGNOFTHETIMES',
      row: 10,
      col: 0
    },
    8: {
      clue: 'Which popular TV show did Harry appear on before his music career?',
      answer: 'THEXFACTOR',
      row: 18,
      col: 0
    },
  },
  down: {
    1: {
      clue: 'What was the title of Harry\'s debut solo album',
      answer: 'HARRYSTYLES',
      row: 0,
      col: 13
    },
    2: {
      clue: 'He often mixes masulinity and femininity in his outfits, showcasing what color often?',
      answer: 'PINK',
      row: 0,
      col: 18
    },
    4: {
      clue: 'The name of Harry\'s first band',
      answer: 'WHITEESKIMO',
      row: 2,
      col: 10
    },
    5: {
      clue: 'Movie where Styles played a soldier (2017)',
      answer: 'DUNKIRK',
      row: 8,
      col: 3
    },
    6: {
      clue: 'Former boy band Harry Styles was in',
      answer: 'ONEDIRECTION',
      row: 8,
      col: 8
    },
    9: {
      clue: 'Harry\'s role in Marvel\'s Eternals',
      answer: 'EROS',
      row: 18,
      col: 2
    }
  },
}
